import request from "libs/request"

// 浏览详情
export function contentHit(data) {
  return request({
    url: '/content/hit.do',
    headers: {
      locker: new Date().getTime()
    },
    method: 'POST',
    data: data
  })
}

// 查询列表
export function contentFinds(data) {
  return request({
    url: '/content/finds.do',
    headers: {
      locker: new Date().getTime()
    },
    method: 'POST',
    data: data
  })
}

// 查询单条信息
export function contentFind(data) {
  return request({
    url: '/content/find.do',
    headers: {
      locker: new Date().getTime()
    },
    method: 'POST',
    data: data
  })
}

// 创建
export function contentCreate(data) {
  return request({
    url: '/content/create.do',
    headers: {
      locker: new Date().getTime()
    },
    method: 'POST',
    data: data
  })
}

// 修改
export function contentUpdate(data) {
  return request({
    url: '/content/update.do',
    headers: {
      locker: new Date().getTime()
    },
    method: 'POST',
    data: data
  })
}

// 删除
export function contentDelete(data) {
  return request({
    url: '/content/delete.do',
    headers: {
      locker: new Date().getTime()
    },
    method: 'POST',
    data: data
  })
}